export default __webpack_public_path__ + "static/media/profile.ef711292.svg";